module.exports = __webpack_public_path__ + "img/plain_location_marker.46e53ac8d4c389a8d3d02e1005408d77.png";